import * as colors from './colors';

export const theme = {
  colors,
};
